import { Phone, Mail } from "lucide-react";

export default function FloatingContact() {
  return (
    <div className="fixed bottom-5 left-5 z-40 flex flex-col gap-2 lg:hidden" data-testid="floating-contact">
      <a
        href="tel:+18622354515"
        aria-label="Call KNV Travelz"
        data-testid="floating-call-btn"
        className="h-14 w-14 rounded-full bg-terracotta text-cream flex items-center justify-center shadow-2xl hover:bg-terracottaDeep transition-colors"
      >
        <Phone size={22} />
      </a>
      <a
        href="mailto:tours@knvtravelz.com"
        aria-label="Email KNV Travelz"
        data-testid="floating-email-btn"
        className="h-14 w-14 rounded-full bg-ink text-cream flex items-center justify-center shadow-2xl hover:bg-teal transition-colors"
      >
        <Mail size={22} />
      </a>
    </div>
  );
}
